const setScrollbarWidthProperty = () => {
    document.documentElement.style.setProperty(
        '--scrollbar-width',
        (window.innerWidth - document.body.clientWidth) + 'px',
    )
}

window.addEventListener('load', setScrollbarWidthProperty);
window.addEventListener('resize', setScrollbarWidthProperty);
